// extracted by mini-css-extract-plugin
module.exports = {"avatar":"src-components-Avatar-AvatarComponent-index-module__avatar--BoU-N"};